// extracted by mini-css-extract-plugin
export var actions = "CookieConsent-module--actions--2fd92";
export var card = "CookieConsent-module--card--f4a71";
export var ccBeat = "CookieConsent-module--cc-beat--52e21";
export var ccRise = "CookieConsent-module--cc-rise--c7818";
export var choice = "CookieConsent-module--choice--bed56";
export var close = "CookieConsent-module--close--1107c";
export var customize = "CookieConsent-module--customize--50c1c";
export var detail = "CookieConsent-module--detail--778cd";
export var head = "CookieConsent-module--head--5192e";
export var inlineLink = "CookieConsent-module--inlineLink--e899d";
export var knob = "CookieConsent-module--knob--ef592";
export var lede = "CookieConsent-module--lede--e58a6";
export var links = "CookieConsent-module--links--219ed";
export var pref = "CookieConsent-module--pref--cfcf4";
export var prefDesc = "CookieConsent-module--prefDesc--21991";
export var prefName = "CookieConsent-module--prefName--0b195";
export var prefText = "CookieConsent-module--prefText--9c222";
export var prefs = "CookieConsent-module--prefs--a302c";
export var save = "CookieConsent-module--save--faf4e";
export var title = "CookieConsent-module--title--98094";
export var toggle = "CookieConsent-module--toggle--575da";
export var toggleLocked = "CookieConsent-module--toggleLocked--b8b99";
export var toggleOn = "CookieConsent-module--toggleOn--adaf1";
export var wave = "CookieConsent-module--wave--d1a67";